import { Component } from '@angular/core';

@Component({
    selector: 'app-manage-alert',
    templateUrl: './manageAlert.component.html',
})
export class ManageAlertComponent {}
